import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PurchaseOrdersBox from './components/PurchaseOrdersBox';
import PageTitle from '../../components/shared/PageTitle';
import PageArea from '../../components/shared/PageArea';


const PurchaseOrdersPage = () => {
  const { t } = useTranslation('common');

  return (
    <PageArea>
      <PageTitle subTitle={t('purchaseOrderReceipt.subTitle')}>{t('purchaseOrderReceipt.title')}</PageTitle>
      <Box
        sx={{ mt: '6px' }}>
        <PurchaseOrdersBox />
      </Box>
    </PageArea>
  );
};

export default PurchaseOrdersPage;
